import axios from "axios";
import { getCookies, removeAllCookies } from "./cookieToken";

const http = axios.create({
  baseURL: import.meta.env.APP_URL_API,
  timeout: 30000,
});

http.interceptors.request.use(
  (config) => {
    const token = getCookies("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.data?.error_code === "AUTH-002") {
      removeAllCookies();
      window.location.href = import.meta.env.APP_URL || "/";
      return;
    }
    return Promise.reject(error);
  }
);

export { http };
